import Vue from 'vue';
import Vuex from 'vuex';
import request from '@/Utilities/httpRequest';
import modulePriceCoupons from '@/store/product-page/price-coupons.js';
import modulePDPMobile from '@/store/product-page/mobile-blackrabbit/page-module';
import modulePDPDesktop from '@/store/product-page/desktop-blackrabbit/page-module';
import moduleGallery from '@/store/product-page/gallery';

Vue.use(Vuex);

function initialState(){
    return {
        kStrings: {},
        groupId: null,
        sku: null,
        masterSku: null,
        commentsTabLabel: null,
        tabSelectd: null,
        productTabs: null,
        tabPackSelection: null,
        urlTabs: null,
        scrollToTabs: null,
        quantityBuy: 1,
        quantityBuyStruct: {},
        // in case of fire, put this a false
        noPreSelection: true, // for cart carousels selected default 
        priceData: {},
        stockLabel: null,
        deliveryInfo: {},
        deliveryInfoUrl: null,
        blockImages: false,
        hasStock: true,
        breadcrumbs: null,
        blocksColor: '#ABABAB',
        showStockLabel:true,
        showMoreInfoModal: false,
        enablePointsPurchase: false,
        cartPointsInfo: null,
      };
  }

  export const storePdp = (() => new Vuex.Store({
    strict: true,
    state: initialState,
    mutations: {
        setKstrings(state, payload) {
            state.kStrings = payload;
        },
        changeGroupId(state, groupId) {
            if(state.groupId != groupId){
                state.groupId = groupId;
                //console.log('updated groupId: ', state.groupId);
            }
        },
        changeMasterSku(state, masterSku) {
            if(state.masterSku != masterSku){
                state.masterSku = masterSku;
            }
        },
        changeSKU(state, sku) {
            if(state.sku != sku){
                state.sku = sku;
            }
        },
        commentsLabel(state,label){
            state.commentsTabLabel = label;
        },
        blockImages(state,value){
            state.blockImages = value;
        },
        tabSelected(state, tab) {
            state.tabSelectd = tab;
        },
        changeTabs(state,tabs){
            state.productTabs = tabs;
        },
        packSelected(state,option){
            state.tabPackSelection = option;
        },
        setUrlTabs(state,url){
            state.urlTabs = url;
        },
        moveToTabs(state, value){
            state.scrollToTabs = value;
        },
        noDefaultCarousel(state, value) {
            state.noPreSelection = value;
        },
        quantityBuyStruct(state, value) {
            state.quantityBuyStruct = value;
        },
        quantityBuy(state, value) {
            state.quantityBuy = value;
        },
        updatePrice(state, value){
            state.priceData = {
                price: value && value.hasOwnProperty('price') ? value.price : null,
                priceReference: value && value.hasOwnProperty('priceReference') ? value.priceReference : null,
                bestPriceCoupon: value && value.hasOwnProperty('bestPriceCoupon') ? value.bestPriceCoupon : null
            };       
        },
        updateStockLabel(state, text){
            if(text) {
                //console.log(text);
                state.stockLabel = text;
            }
        },
        showStockLabel(state, value){
            if(!value){
                state.showStockLabel = false;
            }else{
                state.showStockLabel = true;
            }
        },
        showMoreInfoModal(state, value){
            if(!value){
                state.showMoreInfoModal = false;
            }else{
                state.showMoreInfoModal = true;
            }
        },
        updateHasStock(state, value){
            state.hasStock = value;
        },
        setDeliveryInfoUrl(state, url){
            state.deliveryInfoUrl = url;
        },
        setDeliveryInfo(state, payload){
            state.deliveryInfo = Object.assign({}, state.deliveryInfo, payload);
            //console.log(' STORE deliveryInfo: ', state.deliveryInfo);
        },
        setBreadcrumbs(state, payload){
            state.breadcrumbs = payload;
        },
        setBlocksColor(state, payload) {
            state.blocksColor = payload;
        },
        reset(state){
          // acquire initial state
          const s = initialState()
          Object.keys(s).forEach(key => {
            state[key] = s[key]
          });
        },
        setEnablePointsPurchase(state, payload) {
            state.enablePointsPurchase = payload;
        },
        setCartPointsInfo(state, payload) {
            state.cartPointsInfo = payload;
        },
      },
    actions:{
        updateKstrings(context, payload) {
            context.commit('setKstrings', payload);
        },
        changeGroupId(context, payload) {
            if (payload != context.getters.GroupId) {
                context.commit('changeGroupId', payload.id);
                if(payload.masterSku) {
                    context.commit('changeMasterSku', payload.masterSku);
                }
                if (context.getters.GroupId) {
                    context.dispatch('loadTabs', {id: payload.id, sku: context.getters.SKU});
                }
            }
        },
        changeSKU(context, payload) {
            let sku = payload.sku;
            let sameImages = payload.hasOwnProperty('sameImages') ? payload.sameImages : false;
            context.commit('blockImages',sameImages);
            if(sku != context.getters.SKU){
                context.commit('changeSKU',sku);
                context.dispatch('requestDeliveryInfo',{
                    groupId: context.getters.GroupId,
                    varSku: sku,
                    stock: context.getters.hasStock
                });
            }
            context.dispatch('quantityBuy',sku);
        },
        quantityBuy(context, sku){
            let committed = false;

            if(context.getters.QuantityBuyStruct && context.getters.QuantityBuyStruct.skuBuyAllVariants == true){
                context.commit('quantityBuy', context.getters.QuantityBuyStruct.quantityBuy);
                if(context.getters['pdpDesktop/addToCartDesktop/selectedProduct'] && context.getters['pdpDesktop/addToCartDesktop/selectedProduct'].stock > 1) {
                    context.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', context.getters.QuantityBuyStruct.quantityBuy);

                }
                if(context.getters['pdpMobile/addToCartMobile/selectedProduct'] && context.getters['pdpMobile/addToCartMobile/selectedProduct'].stock > 1) {
                    context.dispatch('pdpMobile/addToCartMobile/updateCartItemQty', context.getters.QuantityBuyStruct.quantityBuy);
                }
                committed = true;
            } else if(context.getters.QuantityBuyStruct  && context.getters.QuantityBuyStruct.length > 0 && !context.getters.QuantityBuyStruct.skuBuyAllVariants) {
                let findSku = context.getters.QuantityBuyStruct.find(e => e.sku == sku);
                if(findSku) {
                    context.commit('quantityBuy', findSku.quantityBuy);
                    if(context.getters['pdpDesktop/addToCartDesktop/selectedProduct'] && context.getters['pdpDesktop/addToCartDesktop/selectedProduct'].stock > 1) {
                        context.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', findSku.quantityBuy);
                    }
                    if(context.getters['pdpMobile/addToCartMobile/selectedProduct'] && context.getters['pdpMobile/addToCartMobile/selectedProduct'].stock > 1) {
                        context.dispatch('pdpMobile/addToCartMobile/updateCartItemQty', findSku.quantityBuy);
                    }

                    committed = true;
                }
            }
           
            if(!committed){
                context.commit('quantityBuy',1);
            }
        },
        quantityBuyStruct(context, payload){
            context.commit('quantityBuyStruct',payload);
            context.dispatch('quantityBuy',context.getters.SKU);
        },
        commentsLabel(context, payload) {
            context.commit('commentsLabel',payload);
        },
        packSelected(context, payload) {
            context.commit('packSelected',payload);
        },
        tabSelected(context, tab) {
            if(!tab){
                context.commit('tabSelected', null);
                return;
            }
            context.commit('tabSelected', tab);
            const pack = context.getters.PackEleSelected;
            const id = pack ? pack.groupId : context.getters.GroupId;
            const options = tab.hasOwnProperty('info') && tab.info && tab.info.hasOwnProperty('options') ? tab.info.options : [];
            if(options){
                for(let i = 0; i < options.length; i++){
                    if(options[i].groupId == id){
                        context.commit('packSelected', options[i]);
                        return;
                    }
                }
                context.commit('packSelected', options[0]);
            }
            else{
                const selOpt  = {groupId: context.getters.GroupId, sku: context.getters.SKU, name: ''};
                context.commit('packSelected', selOpt);
            }
        },
        selectTabByKey(context, obj) {
            const tabs = context.getters.Tabs;
            if(tabs && tabs.length > 0){
                const tab = tabs.find(t => t.key == obj.key);
                context.dispatch('tabSelected', tab ? tab : tabs[0]);
            }
            if(obj.move){
                context.commit('moveToTabs',1);
            }
        },
        initInfo(context,data){
            if(data && data.hasOwnProperty('groupId')){
                //if(!context.getters.GroupId){
                    context.commit('changeGroupId',data.groupId);
                //}
            }
            if(data && data.hasOwnProperty('sku')){
                //if(!context.getters.SKU){
                    context.commit('changeSKU',data.sku);
                //}
            }
        },
        initTabs(context, payload) {
            if(!context.getters.Tabs){
                const url  = payload && payload.hasOwnProperty('url') ? payload.url : null;
                if(url){
                    context.commit('setUrlTabs',url);
                }
                const tabs = payload.tabs;
                context.commit('changeTabs',tabs);
                /*if(tabs && tabs.length>0){
                    context.dispatch('tabSelected', tabs[0]);
                }*/
                let urlLocation = new URL(window.location.href);
                let labelNutrition = urlLocation.searchParams.get('label');
                let comment = urlLocation.searchParams.get('comment');
                if(labelNutrition) {
                    context.commit('moveToTabs',1);
                }
                if(comment) {
                    context.commit('moveToTabs',2);
                }
            }
        },
        async loadTabs(context,payload){
            const url = context.getters.UrlTabs;
            if(!url){
                return;
            }
            const keyTab = context.getters.TabSelected ? context.getters.TabSelected.key : null;
            context.commit('changeTabs', null);
            context.commit('packSelected', null);
            request.cancelLastCall(url);
            const { data } = await request.get(url, payload, false);
            if(data && data.hasOwnProperty('tabsData')){
                context.commit('changeTabs',data.tabsData);
                /*const tabs = data.tabsData.filter(t => t.key == 'PRODUCT_INFO' || t.key == 'INFO_AND_CARE' || t.key == 'MANUALS_DOCUMENTATION');
                if(keyTab){
                    context.dispatch('selectTabByKey',{key: (tabs.length > 1 ? '' : keyTab), move: 0});
                }*/
            }
        },
        
        moveToTabs(context, value){
            context.commit('moveToTabs',value);
        },
        noDefaultCarousel(context, value){
            context.commit('noDefaultCarousel',value);
        },
        updatePrice(context, payload){
            context.commit('updatePrice', payload);
        },
        updateStockLabel(context, payload){
            context.commit('updateStockLabel', payload);
        },
        updateHasStock(context, payload){
            context.commit('updateHasStock', payload);
        },
        setDeliveryInfoUrl(context, payload) {
            context.commit('setDeliveryInfoUrl', payload);
        },
        async requestDeliveryInfo(context, payload) {
            const url = context.getters.deliveryInfoUrl;
            if(!url || (payload.hasOwnProperty('groupStatus') && payload.groupStatus === 'TI')){
                return;
            }
            let data = null;
            if(payload.hasOwnProperty('stock') && !payload.stock){
                data = {
                    renderDeliveryInfo: false,
                    postalCode: null
                };
            }else{
                if(payload.hasOwnProperty('groupId') && payload.hasOwnProperty('varSku') && payload.groupId && payload.varSku){
                    const rst = await request.get(url, {
                        groupId: payload.groupId,
                        sku: payload.varSku
                    });
                    data = rst.data;
                }
            }
            if(data !== null){
                context.commit('setDeliveryInfo', data);
            }
        },
        setBreadcrumbs(context, payload){
            context.commit('setBreadcrumbs', payload);
        },
        updateBreadcrumbsTail(context, payload){
            const current = [...context.state.breadcrumbs];
            payload.pos = current.length;
            current.pop();
            current.push(payload);
            context.commit('setBreadcrumbs', current);    
        },
        updateBlocksColor(context, payload) {
            context.commit('setBlocksColor', payload);
        },
        showStockLabel(context, payload){
            context.commit('showStockLabel', payload);
        },
        showMoreInfoModal(context, payload){
            context.commit('showMoreInfoModal', payload);
        },
        reset(context){
            context.dispatch('priceCoupons/reset');
            context.dispatch('pdpMobile/reset');
            context.dispatch('pdpDesktop/reset');
            context.dispatch('gallery/reset');
            context.commit('reset');
        },
        updateEnablePointsPurchase(context, payload){
            context.commit('setEnablePointsPurchase', payload);
        },
        updateCartPointsInfo(context, payload){
            context.commit('setCartPointsInfo', payload);
        },
    },
    getters:{
        kStrings: state => state.kStrings,
        GroupId: state => state.groupId,
        masterSku: state => state.masterSku,
        SKU: state => state.sku,
        CommentsLabel: state => state.commentsTabLabel,
        TabSelected: state => state.tabSelectd,
        Tabs: state => state.productTabs,
        PackEleSelected: state => state.tabPackSelection,
        UrlTabs: state => state.urlTabs,
        ScrollToTabs: state => state.scrollToTabs,
        NoDefaultCarousel: state => state.noPreSelection,
        QuantityBuyStruct: state => state.quantityBuyStruct,
        QuantityBuy: state => state.quantityBuy,
        priceData: state => state.priceData,
        stockLabel: state => state.stockLabel,
        deliveryInfo: state => state.deliveryInfo,
        deliveryInfoUrl: state => state.deliveryInfoUrl,
        blockImages: state => state.blockImages,
        hasStock: state => state.hasStock,
        breadcrumbs: state => state.breadcrumbs,
        blocksColor: state => state.blocksColor,
        showStockLabel: state => state.showStockLabel,
        showMoreInfoModal: state => state.showMoreInfoModal,
        enablePointsPurchase: state => state.enablePointsPurchase,
        cartPointsInfo: state => state.cartPointsInfo,
    },
    modules: {
        priceCoupons: modulePriceCoupons,
        pdpMobile: modulePDPMobile,
        pdpDesktop: modulePDPDesktop,
        gallery: moduleGallery
    }
}))();
